import React from "react";
import Layout from "../../components/Layout";

const PrivacyContainer = () => (
  <Layout title={"Privacy Policy"}>
    <div>
      <p>
        This page is used to inform web application visitors regarding our
        policies with the collection, use, and disclosure of Personal
        Information if anyone decided to use our Service, the IYF Ghaziabad.com
        web application. If you choose to use our Service, then you agree to the
        collection and use of information in relation with this policy. The
        Personal Information that we collect are used for providing and
        improving the Service. We will not use or share your information with
        anyone except as described in this Privacy Policy. The terms used in
        this Privacy Policy have the same meanings as in our Terms and
        Conditions, which is accessible at web application URL, unless otherwise
        defined in this Privacy Policy.
      </p>
      <div className="bold">Information Collection and Use</div>
      <p>
        For a better experience while using our Service, we may require you to
        provide us with certain personally identifiable information, including
        but not limited to your name, email address, phone number. The
        information that we collect will be used to contact or identify you. The
        information is shared to IYF Ghaziabad and is only used for
        communication services by the person user choose to converse with. This
        information would never shared to any third party vendor, organization,
        indivdual, or tool. This data would help us to identify your identity
        for the services we provide.
      </p>
      <div className="bold">Service Providers</div>
      We may employ third-party companies and individuals due to the following
      reasons:
      <ul>
        <li>To facilitate our Service;</li>
        <li>To provide the Service on our behalf;</li>
        <li>To perform Service-related services; or</li>
        <li>To assist us in analyzing how our Service is used.</li>
      </ul>
      We want to inform our Service users that these third parties have access
      to your Personal Information. The reason is to perform the tasks assigned
      to them on our behalf. However, they are obligated not to disclose or use
      the information for any other purpose.
      <div className="bold">Security</div>
      <p>
        We value your trust in providing us your Personal Information, thus we
        are striving to use commercially acceptable means of protecting it. But
        remember that no method of transmission over the internet, or method of
        electronic storage is 100% secure and reliable, and we cannot guarantee
        its absolute security.
      </p>
      <p>
        We use HTTPS and SSL certification to secure all the network connections
        while using our service. This ensures that the data should pass through
        a secured layer and in encrypted format and not to be intercepted by any
        intruder or attack.
      </p>
      <div className="bold">Links to Other Sites</div>
      <p>
        Our Service may contain links to other sites. If you click on a
        third-party link, you will be directed to that site. Note that these
        external sites are not operated by us. Therefore, we strongly advise you
        to review the Privacy Policy of these websites. We have no control over,
        and assume no responsibility for the content, privacy policies, or
        practices of any third-party sites or services.
      </p>
      <div className="bold">Children's Privacy</div>
      <p>
        Our Services do not address anyone under the age of 13. We do not
        knowingly collect personal identifiable information from children under
        13. In the case we discover that a child under 13 has provided us with
        personal information, we immediately delete this from our servers. If
        you are a parent or guardian and you are aware that your child has
        provided us with personal information, please contact us so that we will
        be able to do necessary actions.
      </p>
      <div className="bold">Changes to This Privacy Policy</div>
      <p>
        We may update our Privacy Policy from time to time. Thus, we advise you
        to review this page periodically for any changes. We will notify you of
        any changes by posting the new Privacy Policy on this page. These
        changes are effective immediately, after they are posted on this page.
      </p>
      <div className="bold">Contact Us</div>
      <p>
        If you feel any violations of rules aforementioned by any of the entity,
        kindly report the issue to the below mentioned details. If you have any
        questions or suggestions about our Privacy Policy, do not hesitate to
        contact us at connecttokrishnanow@gmail.com
      </p>
    </div>
  </Layout>
);

export default PrivacyContainer;
